import axios from '@/utils/axios'
import {getBackendByRole} from '@/utils/role'
import {business, tenantUserPrefix} from '@/api/common'

/**
 * 登出
 * @returns {AxiosPromise}
 */
export const loginOut = () => {
  return axios({
    url: `${getBackendByRole()}/user/loginOut`,
    method: 'post',
    headers: {
      NotNeedAuthorization: true
    }
  })
}

/**
 * 修改管理人员密码
 * @param form
 * @returns {AxiosPromise}
 */
export const modifyPassword = form => {
  return axios({
    url: `${getBackendByRole()}/user/modifyPassword`,
    method: 'post',
    data: form
  })
}

export const unbindYz365 = (id) => {
  return axios({
    url: `${business}${tenantUserPrefix}/tenant/user/unbind/${id}`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/common/auth/authUser.js